<div class="member-info" *ngFor="let member of accordMembers | values">
   <div>
    <img src="/assets/images/avatar.png" class="avatar-circle">
    <h5 class="memberName-custom">{{member.name}} ({{member.count}})</h5>
   </div>
</div>
